"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconButton = _interopRequireDefault(require("./icon-button"));

var _labelButton = _interopRequireDefault(require("./label-button"));

var Button = function Button(props) {
  var type = props.type,
      disabled = props.disabled,
      label = props.label,
      icon = props.icon,
      fullWidth = props.fullWidth,
      variant = props.variant,
      marginTop = props.marginTop,
      onClick = props.onClick,
      tooltip = props.tooltip;

  if (label || !icon) {
    return /*#__PURE__*/_react.default.createElement(_labelButton.default, {
      type: type,
      disabled: disabled,
      label: label,
      icon: icon,
      fullWidth: fullWidth,
      variant: variant,
      marginTop: marginTop,
      onClick: onClick
    });
  } else {
    return /*#__PURE__*/_react.default.createElement(_iconButton.default, {
      onClick: onClick,
      icon: icon,
      tooltip: tooltip
    });
  }
};

var _default = Button;
exports.default = _default;